import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import gif from "../../Assets/kstore.gif";
import Styles from "./Header.module.css";
import upscroll from "../../Assets/upscroll.png";
import { useAuth } from "../../Services/Context";
import VaniGoLogo from "../../Assets/vanigo_logo.png";

export default function Header(props) {
  const { user } = useAuth();
  const [isMenu, setIsMenu] = useState(false);

  const scrollHandle = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (isMenu) {
      document.addEventListener("click", handleListener);
    } else {
      document.removeEventListener("click", handleListener);
    }
    return () => document.removeEventListener("click", handleListener);
  }, [isMenu]);

  const handleListener = (e) => {
    if (!e.target.closest("#menu")) {
      setIsMenu(false);
      props.MenuEnable(false);
      document.body.style.overflow = !isMenu ? "hidden" : "auto";
    }
  };

  const handleMenu = () => {
    setIsMenu((p) => !p);
    props.MenuEnable(!isMenu);
    document.body.style.overflow = !isMenu ? "hidden" : "auto";
  };

  return (
    <div id="home" className={Styles.test + " pt-4"}>
      <div className={Styles.headerContainer}>
        {/* LEFT LOGO */}
        <div
          className={`${Styles.headerLeft} ${isMenu ? Styles.hideLogo : ""}`}
        >
          <img className={Styles.log} src={VaniGoLogo} alt="vanigo" />
        </div>

        {/* CENTER LOGO */}
        <div
          className={`${Styles.headerCenter} ${isMenu ? Styles.hideLogo : ""}`}
        >
          <img className={Styles.log} src={gif} alt="kstore" />
        </div>

        {/* RIGHT MENU BUTTON */}
        <div className={Styles.headerRight}>
          <div
            className={
              isMenu
                ? Styles.materialBtn + " " + Styles.active
                : Styles.materialBtn
            }
          >
            <div
              onClick={handleMenu}
              id="menu"
              className={
                isMenu
                  ? Styles.materialHamburger + " " + Styles.materialClose
                  : Styles.materialHamburger
              }
            >
              <div className={Styles.materialPatty}></div>
              <div className={Styles.materialPatty}></div>
              <div className={Styles.materialPatty}></div>
            </div>
          </div>
        </div>

        {/* MENU ITEMS OVERLAY */}
        <div className="">
          <div
            className={Styles.materialMenu}
            style={{ display: isMenu ? "block" : "none" }}
          >
            <div className={Styles.materialContent}>
              <nav>
                <ul className={Styles.menuLinks}>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#home">
                      Home
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#about">
                      About KSTORe
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#highlights">
                      Key Highlights
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#stores">
                      Store Locator
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#franchise">
                      For Franchise
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#testimonial">
                      Testimonials
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#partners">
                      Brand Partners
                    </a>
                  </li>
                  <li className="p-0">
                    <a className="fontBold fs-2" href="#contact">
                      Contact Us
                    </a>
                  </li>
                  <li className="p-0">
                    <Link
                      to={user !== null ? "/store" : "/auth"}
                      className="fontBold fs-3"
                    >
                      Van!go Login
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* SCROLL TO TOP BUTTON */}
      <div>
        <button
          data-aos="fade"
          onClick={scrollHandle}
          className={Styles.upScrollContainer}
        >
          <img className={Styles.upscrollImg} src={upscroll} alt="scroll" />
        </button>
      </div>
    </div>
  );
}
